const getTypeOptions = () => [{
  name: '按年',
  value: 'year',
}, {
  name: '按月',
  value: 'month',
}, {
  name: '按日期',
  value: 'day',
}];

export default getTypeOptions;
